import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
} from "reactstrap";
import { toast } from "react-toastify";
import { apiURL } from '../../config';

import axios from "axios";

const CustomTable = ({ columns, data }) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data && data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {column.toLowerCase() === "actions"
                                        ? row.actions
                                        : row[column.toLowerCase().replace(/ /g, "")]}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length}>No data available</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

const Subjects = () => {
    const token = localStorage.getItem("token");

    const [searchQuery, setSearchQuery] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [subjectToDelete, setSubjectToDelete] = useState(null);
    const [subjectDeleteModalOpen, setSubjectDeleteModalOpen] = useState(false);
    const [subjectToView, setSubjectToView] = useState(null);
    const [subjectViewModalOpen, setSubjectViewModalOpen] = useState(false);
    const [subjectToEdit, setSubjectToEdit] = useState(null);
    const [subjectEditModalOpen, setSubjectEditModalOpen] = useState(false);
    const [editSubjectName, setEditSubjectName] = useState("");
    const [editSubjectCode, setEditSubjectCode] = useState("");
    const [subjectName, setSubjectName] = useState("");
    const [subjectCode, setSubjectCode] = useState("");
    const [subjectModalOpen, setSubjectModalOpen] = useState(false);

    useEffect(() => {
        fetchSubjects();
    }, []);

    const fetchSubjects = async () => {
        try {
            const response = await axios.get(
                `${apiURL}/superadmin/subjects`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // Add the token to the headers
                    }
                }

            );
            setSubjects(response.data);
        } catch (error) {
            toast.error("Error fetching subjects. Refresh the page");

            // console.error("Error fetching subjects:", error);
        }
    };

    const handleViewSubject = (subject) => {
        setSubjectToView(subject);
        setSubjectViewModalOpen(true);
    };

    const toggleSubjectViewModal = () => {
        setSubjectToView(null);
        setSubjectViewModalOpen(!subjectViewModalOpen);
    };

    const handleEditSubject = (subject) => {
        setSubjectToEdit(subject);
        setEditSubjectName(subject.name);
        setEditSubjectCode(subject.subjectCode);
        setSubjectEditModalOpen(true);
    };

    const toggleSubjectEditModal = () => {
        setSubjectToEdit(null);
        setSubjectEditModalOpen(!subjectEditModalOpen);
    };

    const handleUpdateSubject = async (e) => {
        e.preventDefault();
        try {
            await axios.put(
                `${apiURL}/superadmin/subjects/${subjectToEdit._id}`,
                {
                    name: editSubjectName,
                    subjectCode: editSubjectCode,
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add token to headers
                    },
                }
            );
            fetchSubjects();
            toggleSubjectEditModal();
            toast.success("Subject Updated successfully!");


        } catch (error) {
            toast.error("Error updating subject. Try Again Later");

            // console.error("Error updating subject:", error);
        }
    };

    const handleDeleteSubject = (subject) => {
        setSubjectToDelete(subject);
        setSubjectDeleteModalOpen(true);
    };

    const confirmDeleteSubject = async () => {
        try {
            await axios.delete(
                `${apiURL}/superadmin/subjects/${subjectToDelete._id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add token to headers
                    },
                }
            );
            fetchSubjects();
            setSubjectDeleteModalOpen(false);
            toast.success("Subject Deleted successfully!");

        } catch (error) {
            // console.log(error.status)
            if (error.status === 409) {
                toast.error("Subject is exits in course. First remove it from Course.");
                return;

            }
            toast.error("Error deleting subject. Try Again Later");

            // console.error("Error deleting subject:", error);
        }
    };

    const toggleSubjectDeleteModal = () => {
        setSubjectToDelete(null);
        setSubjectDeleteModalOpen(!subjectDeleteModalOpen);
    };

    const handleAddSubject = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${apiURL}/superadmin/subjects`, {
                name: subjectName,
                subjectCode: subjectCode,
            },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add token to headers
                    },
                });
            fetchSubjects();
            setSubjectName("");
            setSubjectCode("");
            toggleSubjectModal();
            toast.success("Subject Added successfully!");

        } catch (error) {
            toast.error("Error adding subject. Try Again Later");

            // console.error("Error adding subject:", error);
        }
    };

    const toggleSubjectModal = () => {
        setSubjectModalOpen(!subjectModalOpen);
    };

    const filteredSubjects = subjects ? subjects.filter(
        (subject) =>
            subject.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            subject.subjectCode.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    const columns = ["Subject Name", "Subject Code", "Actions"];

    return (
        <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Subjects Management</h3>
                <Input
                    type="text"
                    placeholder="Search by Subject Name or Code"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ maxWidth: "300px" }}
                />
                <Button color="primary" onClick={toggleSubjectModal}>
                    Add Subject
                </Button>
            </CardHeader>
            <CardBody>
                <CustomTable
                    columns={columns}
                    data={filteredSubjects ? filteredSubjects.map((subject) => ({
                        subjectname: subject.name,
                        subjectcode: subject.subjectCode,
                        actions: (
                            <div className="d-flex">
                                <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleDeleteSubject(subject)}
                                    className="mr-2"
                                >
                                    Delete
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => handleEditSubject(subject)}
                                    className="mr-2"
                                >
                                    Edit
                                </Button>
                                <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => handleViewSubject(subject)}
                                >
                                    View
                                </Button>
                            </div>
                        ),
                    })) : []}
                />
            </CardBody>

            {/* View Subject Modal */}
            <Modal isOpen={subjectViewModalOpen} toggle={toggleSubjectViewModal}>
                <ModalHeader toggle={toggleSubjectViewModal}>
                    Subject Details
                </ModalHeader>
                <ModalBody>
                    {subjectToView && (
                        <div>
                            <p>
                                <strong>Subject Name:</strong> {subjectToView.name}
                            </p>
                            <p>
                                <strong>Subject Code:</strong> {subjectToView.subjectCode}
                            </p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleSubjectViewModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Edit Subject Modal */}
            <Modal isOpen={subjectEditModalOpen} toggle={toggleSubjectEditModal}>
                <form onSubmit={handleUpdateSubject}>
                    <ModalHeader toggle={toggleSubjectEditModal}>
                        Edit Subject
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="editSubjectName">Subject Name</Label>
                            <Input
                                type="text"
                                id="editSubjectName"
                                placeholder="Enter Subject Name"
                                value={editSubjectName}
                                onChange={(e) => setEditSubjectName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="editSubjectCode">Subject Code</Label>
                            <Input
                                type="text"
                                id="editSubjectCode"
                                placeholder="Enter Subject Code"
                                value={editSubjectCode}
                                onChange={(e) => setEditSubjectCode(e.target.value)}
                                required
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type="submit">
                            Save Changes
                        </Button>
                        <Button color="secondary" onClick={toggleSubjectEditModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>

            {/* Delete Subject Modal */}
            <Modal
                isOpen={subjectDeleteModalOpen}
                toggle={toggleSubjectDeleteModal}
            >
                <ModalHeader toggle={toggleSubjectDeleteModal}>
                    Delete Subject
                </ModalHeader>
                <ModalBody>
                    {subjectToDelete ? (
                        <p>
                            Are you sure you want to delete the subject:{" "}
                            {subjectToDelete.name}?
                        </p>
                    ) : (
                        <p>No subject selected.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteSubject}>
                        Delete
                    </Button>
                    <Button color="secondary" onClick={toggleSubjectDeleteModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Add Subject Modal */}
            <Modal isOpen={subjectModalOpen} toggle={toggleSubjectModal}>
                <form onSubmit={handleAddSubject}>
                    <ModalHeader toggle={toggleSubjectModal}>Add Subject</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="subjectName">Subject Name</Label>
                            <Input
                                type="text"
                                id="subjectName"
                                placeholder="Enter Subject Name"
                                value={subjectName}
                                onChange={(e) => setSubjectName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="subjectCode">Subject Code</Label>
                            <Input
                                type="text"
                                id="subjectCode"
                                placeholder="Enter Subject Code"
                                value={subjectCode}
                                onChange={(e) => setSubjectCode(e.target.value)}
                                required
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type="submit">
                            Add Subject
                        </Button>
                        <Button color="secondary" onClick={toggleSubjectModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>
        </Card>
    );
};

export default Subjects;
